import {ValidationType} from './ValidationType'

export const ContactsValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  LastName: {
    validationType: ValidationType.NameUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  FirstNames: {
    validationType: ValidationType.NameUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  Salutation: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: true,
    maxLength: 50,
    maxValue: 0
  },
  TitleID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  TypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  StatusID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  StatusDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  SourceID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  ProfessionID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UpdatedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AssignedUserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  SiteID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  BirthDate: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  PrimaryContact: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LinkedTo: {
    validationType: ValidationType.ContactLink,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Email: {
    validationType: ValidationType.Email,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  EmailAlt: {
    validationType: ValidationType.Email,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  WebPage: {
    validationType: ValidationType.WebPage,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  MobileTelephone: {
    validationType: ValidationType.TelephoneNumber,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  CardID: {
    validationType: ValidationType.TextUpperCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  CardRequired: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  TelephoneList: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  EmailingList: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  MailingList: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SMSList: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  MailingAddress: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  MailingCheckedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  MailingRenewalDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  HomeCountryCode: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  HomeProperty: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  HomeStreet: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  HomeLocality: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  HomeTown: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  HomePostcode: {
    validationType: ValidationType.PostCode,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  HomeRegion: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  HomeCountry: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  HomeTelephone: {
    validationType: ValidationType.TelephoneNumber,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  HomeTelephoneAlt: {
    validationType: ValidationType.TelephoneNumber,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  HomeFax: {
    validationType: ValidationType.TelephoneNumber,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessCompany: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 100,
    maxValue: 0
  },
  BusinessJobTitle: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  BusinessCountryCode: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  BusinessProperty: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  BusinessStreet: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  BusinessLocality: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessTown: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessPostcode: {
    validationType: ValidationType.PostCode,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessRegion: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessCountry: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessTelephone: {
    validationType: ValidationType.TelephoneNumber,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessFax: {
    validationType: ValidationType.TelephoneNumber,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  BusinessDepartment: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 50,
    maxValue: 0
  },
  BusinessQualifications: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 100,
    maxValue: 0
  },
  BusinessDX: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  OverseasTaxMethod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DeductTaxRateID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  FICOApprovalNumber: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  FICOApprovalDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  PreferredDeliveryMethod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  NINumber: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  PreferredRentDemandMethod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ManagementTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyManagementType: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyIntroductionFee: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 12,
    maxValue: 79228162514264337593543950335
  },
  PropertyIntroductionPercentage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 100
  },
  PropertyManagementFee: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 11,
    maxValue: 79228162514264337593543950335
  },
  PropertyManagementPercentage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 100
  },
  ProcessOutlookEmails: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PreferredFeedbackMethod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PreferredFeedbackReportMethod: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  InvoiceFeesSeparately: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PassDataTo3rdParties: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PassDataToIFA: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PassDataToConveyancer: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  LocalAuthorityLLRegistration: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  GuarantorID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  CustomBankAccounts: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ClientBankAccountID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  DepositBankAccountID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  UploadData: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ConsolidatedPayments: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  PaymentDay: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  ConsolidatedFloat: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 12,
    maxValue: 79228162514264337593543950335
  },
  PassportNumber: {
    validationType: ValidationType.InternationalPassportNumber,
    isRequired: false,
    maxLength: 44,
    maxValue: 0
  },
  DrivingLicenceNumber: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  MarketingPreferencesSentDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  MarketingPreferencesConfirmedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  TaxReferenceNumber: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  WorkOrderCommissionFee: {
    validationType: ValidationType.Currency,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  WorkOrderCommissionPercentage: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  PausePaymentRun: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  }
};
